import {forceUpdateOnResize} from '../../lib/utils'

export default {
  data() {
    return {
      appWidth: document.body.offsetWidth
    }
  },
  mounted() {
    forceUpdateOnResize(this)
  },
  methods: {
    setAppWidth(width) {
      this.appWidth = width
    }
  }
}

